'use client'

import {usePathname, useRouter, useSearchParams} from 'next/navigation'
import {useState, useEffect} from 'react'
import useQueryStringGenerator from '~/design-system/hooks/useQueryStringGenerator'
import {isValidSortOrder} from '~/design-system/utils'
import HgSortButton, {type SortOrder} from '../../HgSortButton'
import {type HgTableSortProperties} from '../types'

export const TableTitleSortButton = ({
  sortProperties,
}: {
  sortProperties: HgTableSortProperties
}) => {
  const [currentSortOrder, setCurrentSortOrder] = useState<SortOrder>('none')
  const searchParams = useSearchParams()
  const createQueryString = useQueryStringGenerator()
  const router = useRouter()
  const pathname = usePathname()
  const {columnName, isSortable, sortType} = sortProperties || {}

  useEffect(() => {
    if (!isSortable) return

    const sortBy = searchParams.get('sortBy') || ''
    // only allow one column to be sorted at a time
    const [sortColumn, sortOrder] = sortBy.split('_')

    if (!isValidSortOrder(sortOrder) || sortColumn !== columnName) {
      setCurrentSortOrder('none')
      return
    }

    setCurrentSortOrder(sortOrder as SortOrder)
  }, [columnName, isSortable, searchParams])

  const updateSortByParams = (sortOrder: SortOrder) => {
    if (!sortOrder || sortOrder === 'none') {
      const params = new URLSearchParams(searchParams.toString())
      params.delete('sortBy')
      params.delete('page')
      router.push(`${pathname}?${params.toString()}`, {
        scroll: false,
      })
      return
    }

    const sortByValue = `${String(columnName)}_${String(sortOrder)}`
    router.push(createQueryString({page: '', sortBy: sortByValue}), {
      scroll: false,
    })
  }
  return (
    <HgSortButton
      className="static before:absolute before:left-0 before:top-0 before:z-0 before:block before:h-full before:w-full before:cursor-pointer"
      handleSort={updateSortByParams}
      sortOrder={currentSortOrder}
      sortType={sortType}
    />
  )
}
